const extractFields = (payload = {}, fields = []) => {
  if (typeof payload !== "object") return {};

  const extractedPayload = {};
  for (const field of fields) {
    if (payload[field] !== undefined) {
      extractedPayload[field] = payload[field];
    }
  }
  return extractedPayload;
};

export default extractFields;
